import React from 'react';
import { View, Text as RNText, Image, TouchableOpacity, StyleSheet } from 'react-native';
import { useTheme } from '@react-navigation/native';
import { Theme } from '@theme';
import { Icon as CustomIcon } from '@components';
import { Scope } from '@utils';
import { useGetContactById } from '@hooks';
import { defaultImage } from '@assets';

interface ContactChipProps {
  contactId: string;
  readOnly?: boolean;
  onRemove: () => void;
}

export const ContactChip: React.FC<ContactChipProps> = ({ contactId, readOnly = false, onRemove }) => {
  const theme = useTheme();
  const styles = getStyles(theme);
  const { data: contact, isLoading } = useGetContactById(contactId);

  if (isLoading || !contact) {
    return null;
  }

  const color = contact.scope === Scope.PROFESSIONAL
    ? theme.colors.primary
    : theme.colors.green;

  return (
    <View style={[styles.invitedPerson, { backgroundColor: color + '20', borderColor: color }]}>
      <Image source={contact.avatarUrl? { uri: contact.avatarUrl } : defaultImage} style={styles.avatar} />
      <RNText style={[styles.invitedPersonText, { color }]}>{contact.fullName}</RNText>
      {!readOnly && <TouchableOpacity onPress={onRemove}>
        <CustomIcon name="cross" size={theme.iconSize.extraSmall} color="#666" />
      </TouchableOpacity>}
    </View>
  );
};

const getStyles = (theme: Theme) =>
  StyleSheet.create({
    invitedPerson: {
      flexDirection: 'row',
      alignItems: 'center',
      borderRadius: 16,
      borderWidth: 1,
      paddingHorizontal: 12,
      paddingVertical: 6,
      marginRight: 8,
      marginBottom: 8,
    },
    avatar: {
      width: 20,
      height: 20,
      borderRadius: 10,
      marginRight: theme.spacing.sm,
    },
    invitedPersonText: {
      fontSize: 14,
      marginRight: 4,
    },
  });

